import React from "react";
import BaseAdmin from "../AdminPanel/BaseAdmin"
import { Icon, Form, InputNumber, Button, Select, Row, Col, DatePicker, Card, message } from "antd";
import locale from 'antd/es/date-picker/locale/es_ES';
import servdefinitions from "../../Util/AFIPdefinitions_services"
import { API, Auth } from "aws-amplify"

const { Option } = Select;

class CheckInvoices extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            loading:false
        }
    }
    submitFactura(e) {
        e.preventDefault()
        this.props.form.validateFieldsAndScroll({first:true}, (error, values) => {
            if (!error){
                this.setState({ loading: true })
                Auth.currentSession()
                .then(session => {
                    API.get(
                        'test',
                        '/root/invoices/afip/check',
                        {
                            headers: {
                                Authorization: session.getIdToken().getJwtToken()
                            },
                            queryStringParameters: {
                                cbte_modo:          values.cbte_modo,
                                cbte_nro:           values.cbte_nro,
                                cbte_tipo:          parseInt(values.cbte_tipo),
                                cod_autorizacion:   values.cod_autorizacion,
                                cuit_emisor:        values.cuit_emisor,
                                doc_nro_receptor:   values.doc_nro_receptor,
                                doc_tipo_receptor:  parseInt(values.doc_tipo_receptor),
                                cbte_fch:           values.cbte_fch.format("YYYYMMDD"),
                                imp_total:          values.imp_total,
                                pto_vta:            values.pto_vta
                            }
                        }
                    )
                    .then(response => {
                        if (response.resultado === 'A') {
                            message.success("Factura fue validada correctamente")
                        }
                        else {
                            message.error("La factura es apocrifa")
                        }
                        this.setState({ loading: false })
                    })
                    .catch(err => {
                        message.error("Hubo un error enviando la factura")
                        console.log(err)
                        this.setState({ loading: false })
                    })
                })
            }
        })
    }

    render() {
        const { getFieldDecorator } = this.props.form;

        let routes = [
            {
                path: "/admin",
                breadcrumbName: <Icon type="home" />
            },
            {
                path: "/verificar-factura",
                breadcrumbName: "Verificar Factura"
            }
        ]

        return (
            <BaseAdmin
                selected="verificar-factura"
                routes={routes}
            >
                <Col lg={12}>
                    <Card
                        title={"Verificar Factura"}
                        style={{ marginBottom: 10}}
                    >
                        <Form
                            onSubmit={(e) => this.submitFactura(e)}
                        >
                            <Form.Item
                                label="Modalidad de Autorización"
                                name="cbte_modo"
                            >
                                {
                                    getFieldDecorator('cbte_modo', {
                                        rules: [{
                                            required: true,
                                            message: 'Modalidad de Autorización requerida'
                                        }],
                                    })(<Select>
                                        {
                                            servdefinitions.modalidad.map(value => {
                                                return <Option key={value.value} value={value.value}>{value.name}</Option>
                                            })
                                        }
                                    </Select>)
                                }

                            </Form.Item>
                            <Form.Item
                                label="CUIT Emisor"
                                name="cuit_emisor"
                            >
                                {
                                    getFieldDecorator('cuit_emisor', {
                                        rules: [{
                                            required: true,
                                            message: 'CUIT Emisor requerido'
                                        }],
                                    })(<InputNumber style={{ width: "100%" }} />)
                                }
                            </Form.Item>
                            <Form.Item
                                label="Tipo de Comprobante"
                                name="cbte_tipo"
                            >
                                {
                                    getFieldDecorator('cbte_tipo', {
                                        rules: [{
                                            required: true,
                                            message: 'Tipo de Comprobante requerido'
                                        }],
                                    })(<Select>
                                        {
                                            servdefinitions.tipocomprobante.map(value => {
                                                return <Option key={value.value} value={value.value}>{value.name}</Option>
                                            })
                                        }
                                    </Select>)
                                }

                            </Form.Item>
                            <Row gutter={10}>
                                <Col lg={8}>
                                    <Form.Item
                                        label='Punto de Venta'
                                        name="pto_vta"
                                    >
                                        {
                                            getFieldDecorator('pto_vta', {
                                                rules: [{
                                                    required: true,
                                                    message: 'Punto de venta requerido'
                                                }],
                                            })(<InputNumber style={{ width: "100%" }} />)
                                        }
                                    </Form.Item>
                                </Col>
                                <Col lg={16}>
                                    <Form.Item
                                    label='Nro. Comprobante'
                                        name="cbte_nro"
                                    >
                                        {
                                            getFieldDecorator('cbte_nro', {
                                                rules: [{
                                                    required: true,
                                                    message: 'Número de comprobante requerido'
                                                }],
                                            })(<InputNumber style={{ width: "100%" }} />)
                                        }
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Form.Item
                                label="Fecha de Comprobante"
                                name="cbte_fch"
                            >
                                {
                                    getFieldDecorator('cbte_fch', {
                                        rules: [{
                                            required: true,
                                            message: 'Fecha de comprobante requerida'
                                        }],
                                    })(<DatePicker
                                        format="DD-MM-YYYY"
                                        locale={locale}
                                        style={{ width: '100%' }}
                                        allowClear={false}
                                    />)
                                }
                            </Form.Item>
                            <Form.Item
                                label="Importe Total"
                                name="imp_total"
                            >
                                {
                                    getFieldDecorator('imp_total', {
                                        rules: [{
                                            required: true,
                                            message: 'Importe total requerido'
                                        }],
                                    })(<InputNumber style={{ width: "100%" }} prefix="$" />)
                                }
                            </Form.Item>
                            <Form.Item
                                label="Código de Autorización"
                                name="cod_autorizacion"
                                rules={[{ required: true, message: 'Ingrese el código de autorización' }]}
                            >
                                {
                                    getFieldDecorator('cod_autorizacion', {
                                        rules: [{
                                            required: true,
                                            message: 'Código de Autorización requerido'
                                        }],
                                    })(<InputNumber style={{ width: "100%" }} />)
                                }
                            </Form.Item>
                            <Row gutter={10}>
                                <Col lg={12}>
                                    <Form.Item
                                        label='Tipo doc. Receptor'
                                        name="doc_tipo_receptor"
                                    >
                                        {
                                            getFieldDecorator('doc_tipo_receptor', {
                                                rules: [{
                                                    required: true,
                                                    message: 'Tipo de documento del receptor requerido'
                                                }],
                                            })(<Select placeholder="Tipo">
                                                {
                                                    servdefinitions.tipodocumento.map(value => {
                                                        return <Option key={value.value} value={value.value}>{value.name}</Option>
                                                    })
                                                }
                                            </Select>)
                                        }
                                    </Form.Item>
                                </Col>
                                <Col lg={12}>
                                    <Form.Item
                                    label='Nro. Doc. Receptor'
                                        name="doc_nro_receptor"
                                    >
                                        {
                                            getFieldDecorator('doc_nro_receptor', {
                                                rules: [{
                                                    required: true,
                                                    message: 'Documento del receptor requerido'
                                                }],
                                            })(<InputNumber style={{ width: "100%" }} placeholder="Número" />)
                                        }
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Button type="primary" htmlType="submit" style={{ marginTop: '10px' }} loading={this.state.loading} >
                                Comprobar
                            </Button>
                        </Form>
                    </Card>
                </Col>
            </BaseAdmin>
        );
    }
}

export default Form.create()(CheckInvoices);
